import classNames from "classnames"
import { useApp } from "../../../hooks/useApp"
import { Text } from "../../ui/Text/Text"
import { Button } from "../../ui/Button/Button"
import { getInitialActivePendantProductVariantIds } from "../../../utils"

interface Props {
  className?: string
}

export const ConfirmationPopup = ({ className }: Props) => {
  const {
    confirmationPopupDisplayed,
    setConfirmationPopupDisplayed,
    setRedirectingToNextPage,
    bufferedMainProduct,
    setBufferedMainProduct,
    bufferedMainProductVariant
  } = useApp()

  return (
    <>
      <div
        className={classNames(
          "fixed z-50 left-0 top-0 right-0 bottom-0 bg-[#343434]",
          "transition-opacity duration-500",
          confirmationPopupDisplayed
            ? "opacity-50 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        )}
        onClick={() => {
          setConfirmationPopupDisplayed(false)
        }}
      />

      <section className={classNames(
        "fixed left-1/2 xl:left-[50%] top-1/2 z-50 w-2/3 w-min-[320px] w-max-[450px] md:w-2/4 xl:w-1/4 rounded-sm -translate-x-1/2 bg-[#FAFAF9]",
        "transform transition-all duration-500",
        confirmationPopupDisplayed
          ? "-translate-y-1/2 opacity-100 pointer-events-auto"
          : "translate-y-[calc(100%+50px)] opacity-0 pointer-events-none",
        className
      )}>
        <div className={classNames(
          "transform transition-all duration-500 delay-300",
          "grid grid-rows-[min-content_1fr_min-content] max-h-[calc(100vh-200px)]",
          confirmationPopupDisplayed
            ? "pointer-events-auto"
            : "translate-y-[50px] opacity-0 pointer-events-none",
        )}>
          <div className="flex flex-col items-center p-5 py-7 overflow-y-auto md:px-12">
            <p>
              <Text style="h4">Are you sure?</Text>
            </p>

            <p className="mt-5 text-center max-w-[310px]">
              <Text style="p">Changing necklace by karat will reset your current pendants selection.</Text>
            </p>

            <p className="flex gap-4 mt-6">
              <Button className="uppercase w-[100px]" color="black" onClick={() => {
                if (!bufferedMainProduct || !bufferedMainProductVariant) return

                setConfirmationPopupDisplayed(false)

                const initialPendantVariantIds = getInitialActivePendantProductVariantIds(bufferedMainProduct, bufferedMainProductVariant.id)
                const bset = [bufferedMainProductVariant.id, ...initialPendantVariantIds].join("-")

                const url = new URL(window.location.href)
                url.pathname = bufferedMainProduct.url
                url.searchParams.set('bset', bset)
                window.history.replaceState({}, "", url.href)

                window.reloadBuilder?.(bufferedMainProduct)
              }}>
                Okay
              </Button>
              <Button className="Button w-[100px] border border-[#1f1f1f] bg-white" color="white" onClick={() => {
                setConfirmationPopupDisplayed(false)
                setRedirectingToNextPage(false)
                setBufferedMainProduct(null) 
              }}>
                Cancel
              </Button>
            </p>
          </div>
        </div>
      </section>
    </>
  )
}